import { render, staticRenderFns } from "./page-header-with-button.vue?vue&type=template&id=6bdd18b4&scoped=true&"
import script from "./page-header-with-button.vue?vue&type=script&lang=js&"
export * from "./page-header-with-button.vue?vue&type=script&lang=js&"
import style0 from "./page-header-with-button.vue?vue&type=style&index=0&id=6bdd18b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd18b4",
  null
  
)

export default component.exports